import { DateTime } from 'luxon'

import SessionQ from '@/queries/SessionQ'
import type { Query } from '@/client/query'

import { EMPTY_RICH_TEXT_VALUE } from '../richText/constants'
import sessionTimeRemoteToLocal from './sessionTimeRemoteToLocal'
import type { SessionCreatorData } from './types'

export default function getSessionCreatorData(session: Query): SessionCreatorData {
  const maxLearners = `${session(SessionQ.max_learners)}`
  const allowCohosts = session(SessionQ.allow_cohosts) ?? false
  const description = session(SessionQ.description) ?? EMPTY_RICH_TEXT_VALUE
  const qualifications = session(SessionQ.qualifications)
  const questionnaire = session(SessionQ.questionnaire)
  const startDate = session(SessionQ.start_date) ?? DateTime.now().toISO()
  const endDate = session(SessionQ.end_date) ?? DateTime.now().toISO()
  const title = session(SessionQ.title)

  const { date, time, duration } = sessionTimeRemoteToLocal({ startDate, endDate })

  return {
    maxLearners,
    duration,
    date,
    time,
    allowCohosts,
    description,
    qualifications,
    questionnaire,
    languages: ['eng'],
    title,
  }
}
